import React, { useEffect, useState, useRef } from 'react';
import { Plus, X, Building2, Target, Sparkles, LayoutList, GitBranch, CheckCircle, Clock, AlertCircle, User, Store, TrendingUp, ChevronDown } from 'lucide-react';
type DealType = 'retail' | 'investment';
const mockDeals = [
// Eugenio's deals (logged user)
{
  id: 1,
  property: 'Via Montenapoleone 12',
  brand: 'Luxury Fashion Brand',
  stage: 'Trattativa',
  value: 850000,
  date: '15/01/2024',
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 3,
  property: 'Via della Spiga 8',
  brand: 'Designer Boutique',
  stage: 'Chiusa',
  value: 650000,
  date: '08/01/2024',
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 6,
  property: 'Piazza Duomo 5',
  brand: 'Tech Startup Milano',
  stage: 'Proposta',
  value: 920000,
  date: '18/01/2024',
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
}, {
  id: 7,
  property: 'Corso Buenos Aires 33',
  brand: 'Fashion Retail Group',
  stage: 'Interesse',
  value: 680000,
  date: '19/01/2024',
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 8,
  property: 'Via Torino 28',
  brand: 'Luxury Watch Brand',
  stage: 'Trattativa',
  value: 1100000,
  date: '17/01/2024',
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
},
// Laura Bianchi's deals
{
  id: 2,
  property: 'Corso Venezia 45',
  brand: 'Premium Lifestyle Co.',
  stage: 'Proposta',
  value: 1200000,
  date: '12/01/2024',
  assignedTo: 'Laura Bianchi',
  assignedToId: 'user-2',
  dealType: 'investment' as DealType
}, {
  id: 5,
  property: 'Via Brera 15',
  brand: 'Luxury Accessories',
  stage: 'Proposta',
  value: 780000,
  date: '14/01/2024',
  assignedTo: 'Laura Bianchi',
  assignedToId: 'user-2',
  dealType: 'investment' as DealType
}, {
  id: 9,
  property: 'Via Manzoni 20',
  brand: 'Contemporary Art Gallery',
  stage: 'Interesse',
  value: 950000,
  date: '16/01/2024',
  assignedTo: 'Laura Bianchi',
  assignedToId: 'user-2',
  dealType: 'investment' as DealType
}, {
  id: 10,
  property: 'Corso Magenta 12',
  brand: 'Jewelry Boutique',
  stage: 'Chiusa',
  value: 720000,
  date: '10/01/2024',
  assignedTo: 'Laura Bianchi',
  assignedToId: 'user-2',
  dealType: 'retail' as DealType
},
// Giuseppe Verdi's deals
{
  id: 4,
  property: 'Corso Como 10',
  brand: 'Emerging Fashion Brand',
  stage: 'Interesse',
  value: 450000,
  date: '16/01/2024',
  assignedTo: 'Giuseppe Verdi',
  assignedToId: 'user-3',
  dealType: 'retail' as DealType
}, {
  id: 11,
  property: 'Via Solferino 8',
  brand: 'Design Studio Milano',
  stage: 'Proposta',
  value: 890000,
  date: '13/01/2024',
  assignedTo: 'Giuseppe Verdi',
  assignedToId: 'user-3',
  dealType: 'investment' as DealType
}, {
  id: 12,
  property: 'Piazza San Babila 7',
  brand: 'International Fashion House',
  stage: 'Trattativa',
  value: 1050000,
  date: '11/01/2024',
  assignedTo: 'Giuseppe Verdi',
  assignedToId: 'user-3',
  dealType: 'retail' as DealType
},
// Mario Rossi's deals
{
  id: 13,
  property: 'Via Dante 15',
  brand: 'Luxury Home Decor',
  stage: 'Interesse',
  value: 620000,
  date: '18/01/2024',
  assignedTo: 'Mario Rossi',
  assignedToId: 'user-4',
  dealType: 'retail' as DealType
}, {
  id: 14,
  property: 'Corso Garibaldi 45',
  brand: 'Cosmetics Brand',
  stage: 'Proposta',
  value: 740000,
  date: '15/01/2024',
  assignedTo: 'Mario Rossi',
  assignedToId: 'user-4',
  dealType: 'retail' as DealType
}, {
  id: 15,
  property: 'Via Fiori Chiari 22',
  brand: 'Artisan Leather Goods',
  stage: 'Chiusa',
  value: 580000,
  date: '09/01/2024',
  assignedTo: 'Mario Rossi',
  assignedToId: 'user-4',
  dealType: 'retail' as DealType
}];
const stageColors: Record<string, string> = {
  Interesse: 'bg-gray-100 text-gray-800 rounded-full',
  Proposta: 'bg-blue-100 text-blue-800 rounded-full',
  Trattativa: 'bg-yellow-100 text-yellow-800 rounded-full',
  Chiusa: 'bg-green-100 text-green-800 rounded-full'
};
const mockProperties = [{
  id: 1,
  name: 'Via Montenapoleone 12',
  price: 850000,
  size: 120,
  type: 'Retail'
}, {
  id: 2,
  name: 'Corso Venezia 45',
  price: 1200000,
  size: 200,
  type: 'Showroom'
}, {
  id: 3,
  name: 'Via della Spiga 8',
  price: 650000,
  size: 90,
  type: 'Boutique'
}];
const mockBrands = [{
  id: 1,
  name: 'Luxury Fashion Brand'
}, {
  id: 2,
  name: 'Premium Lifestyle Co.'
}, {
  id: 3,
  name: 'Designer Boutique'
}];
const mockSuggestedProperties = [{
  id: 1,
  name: 'Via Montenapoleone 12',
  price: 850000,
  size: 120,
  type: 'Retail',
  matchScore: 95,
  reason: 'Perfetta corrispondenza con budget e metratura richiesta. Location premium nel quadrilatero.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg'
}, {
  id: 2,
  name: 'Corso Venezia 45',
  price: 1200000,
  size: 200,
  type: 'Showroom',
  matchScore: 82,
  reason: 'Superficie superiore alle esigenze ma ottima visibilità. Possibilità di suddivisione spazi.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg'
}, {
  id: 3,
  name: 'Via della Spiga 8',
  price: 650000,
  size: 90,
  type: 'Boutique',
  matchScore: 78,
  reason: 'Budget leggermente inferiore ma location esclusiva. Ideale per brand emergenti.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp'
}];
const pipelineStages = [{
  id: 'lead',
  name: 'Opportunità',
  icon: Target,
  activities: ['Primo contatto con il brand', 'Raccolta esigenze preliminari', 'Invio brochure immobili disponibili']
}, {
  id: 'qualification',
  name: 'Elaborazione Proposta',
  icon: CheckCircle,
  activities: ['Verifica budget disponibile', 'Analisi esigenze specifiche', 'Valutazione tempistiche', 'Identificazione decision maker']
}, {
  id: 'proposal',
  name: 'Proposta Inviata',
  icon: Building2,
  activities: ['Preparazione proposta commerciale', 'Presentazione immobili selezionati', 'Sopralluogo con il cliente', 'Invio documentazione tecnica']
}, {
  id: 'negotiation',
  name: 'In Trattativa',
  icon: AlertCircle,
  activities: ['Discussione termini contrattuali', 'Negoziazione prezzo e condizioni', 'Gestione obiezioni', 'Preparazione bozza contratto']
}, {
  id: 'closing',
  name: 'Chiusura',
  icon: CheckCircle,
  activities: ['Firma contratto', 'Gestione documentazione legale', 'Coordinamento passaggio chiavi', 'Follow-up post-vendita']
}];
const pipelineDeals = [
// Lead Stage - Eugenio
{
  id: 4,
  property: 'Corso Como 10',
  brand: 'Emerging Fashion Brand',
  stage: 'lead',
  value: 450000,
  date: '16/01/2024',
  probability: 30,
  nextAction: 'Primo contatto telefonico',
  daysInStage: 3,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 11,
  property: 'Via Manzoni 8',
  brand: 'Urban Style Collective',
  stage: 'lead',
  value: 520000,
  date: '17/01/2024',
  probability: 25,
  nextAction: 'Inviare brochure immobili',
  daysInStage: 2,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 12,
  property: 'Piazza San Babila 3',
  brand: 'Contemporary Design Studio',
  stage: 'lead',
  value: 680000,
  date: '18/01/2024',
  probability: 35,
  nextAction: 'Raccolta esigenze preliminari',
  daysInStage: 1,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
},
// Qualification Stage - Eugenio
{
  id: 5,
  property: 'Via Brera 15',
  brand: 'Luxury Accessories',
  stage: 'qualification',
  value: 780000,
  date: '14/01/2024',
  probability: 50,
  nextAction: 'Verifica budget',
  daysInStage: 4,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
}, {
  id: 13,
  property: "Via Sant'Andrea 12",
  brand: 'Maison de Luxe Paris',
  stage: 'qualification',
  value: 950000,
  date: '13/01/2024',
  probability: 55,
  nextAction: 'Analisi esigenze specifiche',
  daysInStage: 5,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 14,
  property: 'Corso Matteotti 5',
  brand: 'Heritage Luxury House',
  stage: 'qualification',
  value: 820000,
  date: '15/01/2024',
  probability: 48,
  nextAction: 'Identificazione decision maker',
  daysInStage: 3,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
},
// Proposal Stage - Eugenio
{
  id: 6,
  property: 'Corso Venezia 45',
  brand: 'Premium Lifestyle Co.',
  stage: 'proposal',
  value: 1200000,
  date: '12/01/2024',
  probability: 65,
  nextAction: 'Presentare proposta commerciale',
  daysInStage: 6,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
}, {
  id: 15,
  property: 'Via Verri 7',
  brand: 'Atelier Milano',
  stage: 'proposal',
  value: 890000,
  date: '11/01/2024',
  probability: 60,
  nextAction: 'Sopralluogo con il cliente',
  daysInStage: 7,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 16,
  property: 'Via Santo Spirito 10',
  brand: 'Boutique Exclusive Paris',
  stage: 'proposal',
  value: 1050000,
  date: '10/01/2024',
  probability: 70,
  nextAction: 'Invio documentazione tecnica',
  daysInStage: 8,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
},
// Negotiation Stage - Eugenio
{
  id: 1,
  property: 'Via Montenapoleone 12',
  brand: 'Luxury Fashion Brand',
  stage: 'negotiation',
  value: 850000,
  date: '15/01/2024',
  probability: 75,
  nextAction: 'Inviare bozza contratto',
  daysInStage: 5,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 17,
  property: 'Via Gesù 4',
  brand: 'Designer Collective Milano',
  stage: 'negotiation',
  value: 920000,
  date: '09/01/2024',
  probability: 80,
  nextAction: 'Negoziazione prezzo finale',
  daysInStage: 9,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 18,
  property: 'Via Borgospesso 15',
  brand: 'Global Retail Group',
  stage: 'negotiation',
  value: 760000,
  date: '08/01/2024',
  probability: 72,
  nextAction: 'Gestione obiezioni',
  daysInStage: 10,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
},
// Closing Stage - Eugenio
{
  id: 3,
  property: 'Via della Spiga 8',
  brand: 'Designer Boutique',
  stage: 'closing',
  closingSubstage: 'conclusa',
  value: 650000,
  date: '08/01/2024',
  probability: 95,
  nextAction: 'Firma contratto prevista per domani',
  daysInStage: 2,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 19,
  property: 'Via Monte di Pietà 21',
  brand: 'Luxury Accessories House',
  stage: 'closing',
  closingSubstage: 'conclusa',
  value: 720000,
  date: '07/01/2024',
  probability: 90,
  nextAction: 'Coordinamento passaggio chiavi',
  daysInStage: 3,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}, {
  id: 20,
  property: 'Corso Europa 12',
  brand: 'Premium Sportswear Brand',
  stage: 'closing',
  closingSubstage: 'bloccata',
  value: 880000,
  date: '06/01/2024',
  probability: 92,
  nextAction: 'Gestione documentazione legale',
  daysInStage: 4,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'investment' as DealType
}, {
  id: 21,
  property: 'Via Borgonuovo 18',
  brand: 'Fashion House International',
  stage: 'closing',
  closingSubstage: 'rifiutata',
  value: 590000,
  date: '05/01/2024',
  probability: 0,
  nextAction: 'Chiusura pratica',
  daysInStage: 5,
  assignedTo: 'Eugenio',
  assignedToId: 'current-user',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
  dealType: 'retail' as DealType
}];
export function Deals() {
  const [activeTab, setActiveTab] = useState<'list' | 'pipeline'>('list');
  const [showNewDealModal, setShowNewDealModal] = useState(false);
  const [creationType, setCreationType] = useState<'existing' | 'requirement'>('existing');
  const [dealTypeFilter, setDealTypeFilter] = useState<'all' | DealType>('all');
  const [newDealType, setNewDealType] = useState<DealType>('retail');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState('');
  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedStage, setSelectedStage] = useState('');
  const [dealValue, setDealValue] = useState('');
  const [requirementBrand, setRequirementBrand] = useState('');
  const [requirementType, setRequirementType] = useState('');
  const [requirementBudget, setRequirementBudget] = useState('');
  const [requirementSize, setRequirementSize] = useState('');
  const [requirementZone, setRequirementZone] = useState('');
  const [requirementNotes, setRequirementNotes] = useState('');
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const [selectedPipelineStage, setSelectedPipelineStage] = useState<string | null>('lead');
  const [closingSubstageFilter, setClosingSubstageFilter] = useState<'all' | 'bloccata' | 'rifiutata' | 'conclusa'>('all');
  const filterDropdownRef = useRef<HTMLDivElement>(null);
  const currentUserId = 'current-user';
  const pipelineDeals = [
  // Lead Stage - Eugenio
  {
    id: 4,
    property: 'Corso Como 10',
    brand: 'Emerging Fashion Brand',
    stage: 'lead',
    value: 450000,
    date: '16/01/2024',
    probability: 30,
    nextAction: 'Primo contatto telefonico',
    daysInStage: 3,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 11,
    property: 'Via Manzoni 8',
    brand: 'Urban Style Collective',
    stage: 'lead',
    value: 520000,
    date: '17/01/2024',
    probability: 25,
    nextAction: 'Inviare brochure immobili',
    daysInStage: 2,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 12,
    property: 'Piazza San Babila 3',
    brand: 'Contemporary Design Studio',
    stage: 'lead',
    value: 680000,
    date: '18/01/2024',
    probability: 35,
    nextAction: 'Raccolta esigenze preliminari',
    daysInStage: 1,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  },
  // Qualification Stage - Eugenio
  {
    id: 5,
    property: 'Via Brera 15',
    brand: 'Luxury Accessories',
    stage: 'qualification',
    value: 780000,
    date: '14/01/2024',
    probability: 50,
    nextAction: 'Verifica budget',
    daysInStage: 4,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  }, {
    id: 13,
    property: "Via Sant'Andrea 12",
    brand: 'Maison de Luxe Paris',
    stage: 'qualification',
    value: 950000,
    date: '13/01/2024',
    probability: 55,
    nextAction: 'Analisi esigenze specifiche',
    daysInStage: 5,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 14,
    property: 'Corso Matteotti 5',
    brand: 'Heritage Luxury House',
    stage: 'qualification',
    value: 820000,
    date: '15/01/2024',
    probability: 48,
    nextAction: 'Identificazione decision maker',
    daysInStage: 3,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  },
  // Proposal Stage - Eugenio
  {
    id: 6,
    property: 'Corso Venezia 45',
    brand: 'Premium Lifestyle Co.',
    stage: 'proposal',
    value: 1200000,
    date: '12/01/2024',
    probability: 65,
    nextAction: 'Presentare proposta commerciale',
    daysInStage: 6,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  }, {
    id: 15,
    property: 'Via Verri 7',
    brand: 'Atelier Milano',
    stage: 'proposal',
    value: 890000,
    date: '11/01/2024',
    probability: 60,
    nextAction: 'Sopralluogo con il cliente',
    daysInStage: 7,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 16,
    property: 'Via Santo Spirito 10',
    brand: 'Boutique Exclusive Paris',
    stage: 'proposal',
    value: 1050000,
    date: '10/01/2024',
    probability: 70,
    nextAction: 'Invio documentazione tecnica',
    daysInStage: 8,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  },
  // Negotiation Stage - Eugenio
  {
    id: 1,
    property: 'Via Montenapoleone 12',
    brand: 'Luxury Fashion Brand',
    stage: 'negotiation',
    value: 850000,
    date: '15/01/2024',
    probability: 75,
    nextAction: 'Inviare bozza contratto',
    daysInStage: 5,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 17,
    property: 'Via Gesù 4',
    brand: 'Designer Collective Milano',
    stage: 'negotiation',
    value: 920000,
    date: '09/01/2024',
    probability: 80,
    nextAction: 'Negoziazione prezzo finale',
    daysInStage: 9,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 18,
    property: 'Via Borgospesso 15',
    brand: 'Global Retail Group',
    stage: 'negotiation',
    value: 760000,
    date: '08/01/2024',
    probability: 72,
    nextAction: 'Gestione obiezioni',
    daysInStage: 10,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  },
  // Closing Stage - Eugenio
  {
    id: 3,
    property: 'Via della Spiga 8',
    brand: 'Designer Boutique',
    stage: 'closing',
    closingSubstage: 'conclusa',
    value: 650000,
    date: '08/01/2024',
    probability: 95,
    nextAction: 'Firma contratto prevista per domani',
    daysInStage: 2,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 19,
    property: 'Via Monte di Pietà 21',
    brand: 'Luxury Accessories House',
    stage: 'closing',
    closingSubstage: 'conclusa',
    value: 720000,
    date: '07/01/2024',
    probability: 90,
    nextAction: 'Coordinamento passaggio chiavi',
    daysInStage: 3,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }, {
    id: 20,
    property: 'Corso Europa 12',
    brand: 'Premium Sportswear Brand',
    stage: 'closing',
    closingSubstage: 'bloccata',
    value: 880000,
    date: '06/01/2024',
    probability: 92,
    nextAction: 'Gestione documentazione legale',
    daysInStage: 4,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'investment' as DealType
  }, {
    id: 21,
    property: 'Via Borgonuovo 18',
    brand: 'Fashion House International',
    stage: 'closing',
    closingSubstage: 'rifiutata',
    value: 590000,
    date: '05/01/2024',
    probability: 0,
    nextAction: 'Chiusura pratica',
    daysInStage: 5,
    assignedTo: 'Eugenio',
    assignedToId: 'current-user',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png',
    dealType: 'retail' as DealType
  }];
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target as Node)) {
        setIsFilterDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const dealTypeOptions = [{
    value: 'all',
    label: 'Tutte le Tipologie',
    icon: null,
    color: '#374151'
  }, {
    value: 'retail',
    label: 'Retail',
    icon: Store,
    color: '#1388ad'
  }, {
    value: 'investment',
    label: 'Investment',
    icon: TrendingUp,
    color: '#6bb2cd'
  }];
  const selectedDealTypeOption = dealTypeOptions.find(opt => opt.value === dealTypeFilter);
  const filteredDeals = dealTypeFilter === 'all' ? mockDeals : mockDeals.filter(deal => deal.dealType === dealTypeFilter);
  const myDeals = pipelineDeals.filter(deal => deal.assignedToId === currentUserId);
  const filteredPipelineDeals = dealTypeFilter === 'all' ? myDeals : myDeals.filter(deal => deal.dealType === dealTypeFilter);
  const getDealsByStage = (stageId: string) => {
    const stageDeals = filteredPipelineDeals.filter(deal => deal.stage === stageId);
    if (stageId === 'closing' && closingSubstageFilter !== 'all') {
      return stageDeals.filter(deal => deal.closingSubstage === closingSubstageFilter);
    }
    return stageDeals;
  };
  const getTotalValueByStage = (stageId: string) => {
    return getDealsByStage(stageId).reduce((sum, deal) => sum + deal.value, 0);
  };
  const getWeightedValueByStage = (stageId: string) => {
    return getDealsByStage(stageId).reduce((sum, deal) => sum + deal.value * (deal.probability / 100), 0);
  };
  const getStageDisplayName = (stageId: string) => {
    const stageMap: Record<string, string> = {
      lead: 'Opportunità',
      qualification: 'Elaborazione Proposta',
      proposal: 'Proposta Inviata',
      negotiation: 'In Trattativa',
      closing: 'Chiusura'
    };
    return stageMap[stageId] || stageId;
  };
  const getClosingSubstageLabel = (substage: string) => {
    const labels: Record<string, string> = {
      bloccata: 'Bloccata',
      rifiutata: 'Rifiutata',
      conclusa: 'Conclusa'
    };
    return labels[substage] || substage;
  };
  const closingSubstageColors: Record<string, string> = {
    bloccata: 'bg-yellow-100 text-yellow-800',
    rifiutata: 'bg-red-100 text-red-800',
    conclusa: 'bg-green-100 text-green-800'
  };
  const handleAnalyzeRequirement = () => {
    setIsAnalyzing(true);
    setTimeout(() => {
      setIsAnalyzing(false);
      setShowSuggestions(true);
    }, 2000);
  };
  const handleCreateDeal = () => {
    setShowNewDealModal(false);
    setShowSuggestions(false);
  };
  return <div className="space-y-6" data-id="element-1611">
      <div className="flex items-center justify-between" data-id="element-1612">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1613">
          Gestione Trattative
        </h1>
        <div className="flex items-center gap-3" data-id="element-1614">
          {/* Custom Deal Type Filter Dropdown */}
          <div className="relative" ref={filterDropdownRef} data-id="element-1615">
            <button onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)} className="px-4 py-2 bg-gray-100 text-gray-900 text-sm font-normal rounded-full border border-gray-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[#1388ad] transition-colors flex items-center gap-2 min-w-[180px]" data-id="element-1616">
              {selectedDealTypeOption?.icon && <selectedDealTypeOption.icon className="w-4 h-4 flex-shrink-0" data-id="element-1617" />}
              <span className="flex-1 text-left whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-1618">
                {selectedDealTypeOption?.label}
              </span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isFilterDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1619" />
            </button>
            {isFilterDropdownOpen && <div className="absolute top-full right-0 mt-2 w-full min-w-[180px] bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-xl z-50" data-id="element-1620">
                {dealTypeOptions.map(option => {
              const OptionIcon = option.icon;
              const isSelected = dealTypeFilter === option.value;
              return <button key={option.value} onClick={() => {
                setDealTypeFilter(option.value as 'all' | DealType);
                setIsFilterDropdownOpen(false);
              }} className="w-full px-4 py-3 text-left text-sm flex items-center gap-2 transition-colors whitespace-nowrap" style={isSelected ? {
                backgroundColor: option.color,
                color: 'white'
              } : undefined} data-id="element-1621">
                      {OptionIcon && <OptionIcon className="w-4 h-4 flex-shrink-0" data-id="element-1622" />}
                      <span data-id="element-1623">{option.label}</span>
                    </button>;
            })}
              </div>}
          </div>
          <button onClick={() => setShowNewDealModal(true)} className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-1624">
            <Plus className="w-4 h-4" data-id="element-1625" />
            Nuova Trattativa
          </button>
        </div>
      </div>
      {/* Tabs */}
      <div className="flex gap-2 border-b border-gray-200" data-id="element-1626">
        <button onClick={() => setActiveTab('list')} className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${activeTab === 'list' ? 'border-[#1388ad] text-[#1388ad]' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-1627">
          <LayoutList className="w-4 h-4" data-id="element-1628" />
          <span data-id="element-1629">Tutte le Trattative</span>
        </button>
        <button onClick={() => setActiveTab('pipeline')} className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${activeTab === 'pipeline' ? 'border-[#1388ad] text-[#1388ad]' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-1630">
          <GitBranch className="w-4 h-4" data-id="element-1631" />
          <span data-id="element-1632">La Mia Pipeline</span>
        </button>
      </div>
      {/* List View - All Team Deals */}
      {activeTab === 'list' && <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1633">
          <div className="overflow-x-auto" data-id="element-1634">
            <table className="w-full" data-id="element-1635">
              <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1636">
                <tr data-id="element-1637">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1638">
                    Immobile
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1639">
                    Brand
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1640">
                    Responsabile
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1641">
                    Tipologia
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1642">
                    Fase
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1643">
                    Valore
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1644">
                    Data
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-1645">
                {filteredDeals.map(deal => <tr key={deal.id} className="hover:bg-gray-50 transition-colors" data-id="element-1646">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1647">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1648">
                        {deal.property}
                      </p>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1649">
                      <p className="text-sm text-gray-600" data-id="element-1650">{deal.brand}</p>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1651">
                      <div className="flex items-center gap-2" data-id="element-1652">
                        {deal.profileImage ? <img src={deal.profileImage} alt={deal.assignedTo} className="w-8 h-8 rounded-full object-cover" data-id="element-1653" /> : <div className="w-8 h-8 rounded-full bg-[#1388ad] text-white flex items-center justify-center text-xs font-medium" data-id="element-1654">
                            {deal.assignedTo.split(' ').map(n => n[0]).join('')}
                          </div>}
                        <span className="text-sm text-gray-600" data-id="element-1655">
                          {deal.assignedTo}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1656">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1657">
                        {deal.dealType === 'retail' ? <>
                            <Store className="w-3 h-3" data-id="element-1658" />
                            Retail
                          </> : <>
                            <TrendingUp className="w-3 h-3" data-id="element-1659" />
                            Investment
                          </>}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1660">
                      <span className={`px-3 py-1 text-xs ${stageColors[deal.stage]}`} data-id="element-1661">
                        {deal.stage}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1662">
                      <p className="text-sm font-medium text-[#1388ad]" data-id="element-1663">
                        €{deal.value.toLocaleString()}
                      </p>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1664">
                      <p className="text-sm text-gray-500" data-id="element-1665">{deal.date}</p>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
      {/* Pipeline View - My Deals Only */}
      {activeTab === 'pipeline' && <div className="space-y-6" data-id="element-1666">
          {/* Pipeline Stats - Clickable Widgets */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-1667">
            {pipelineStages.map(stage => {
          const deals = getDealsByStage(stage.id);
          const weightedValue = getWeightedValueByStage(stage.id);
          const StageIcon = stage.icon;
          const isSelected = selectedPipelineStage === stage.id;
          return <button key={stage.id} onClick={() => {
            setSelectedPipelineStage(stage.id);
            setClosingSubstageFilter('all');
          }} className={`bg-white p-4 rounded-lg text-left transition-all ${isSelected ? 'border-2 border-[#1388ad] shadow-md' : 'border border-gray-200 hover:border-[#1388ad]/50'}`} data-id="element-1668">
                  <div className="flex items-center justify-between mb-3" data-id="element-1669">
                    <span className={`text-sm font-medium ${isSelected ? 'text-[#1388ad]' : 'text-gray-700'}`} data-id="element-1670">
                      {stage.name}
                    </span>
                    <StageIcon className={`w-5 h-5 ${isSelected ? 'text-[#1388ad]' : 'text-gray-400'}`} data-id="element-1671" />
                  </div>
                  <p className="text-2xl font-semibold text-gray-900 mb-1" data-id="element-1672">
                    {weightedValue.toLocaleString('it-IT')}€
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-1673">
                    {deals.length} trattative
                  </p>
                </button>;
        })}
          </div>
          {/* Filtered Deals Table */}
          {selectedPipelineStage && <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1674">
              <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1675">
                <div data-id="element-1676">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-1677">
                    {pipelineStages.find(s => s.id === selectedPipelineStage)?.name}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1678">
                    {getDealsByStage(selectedPipelineStage).length} trattative
                    in questa fase
                  </p>
                </div>
                {selectedPipelineStage === 'closing' && <div className="flex items-center gap-2" data-id="element-1679">
                    <button onClick={() => setClosingSubstageFilter('all')} className={`px-3 py-1.5 text-sm rounded-full transition-colors ${closingSubstageFilter === 'all' ? 'bg-[#1388ad] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1680">
                      Tutte
                    </button>
                    <button onClick={() => setClosingSubstageFilter('conclusa')} className={`px-3 py-1.5 text-sm rounded-full transition-colors ${closingSubstageFilter === 'conclusa' ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1681">
                      Conclusa
                    </button>
                    <button onClick={() => setClosingSubstageFilter('bloccata')} className={`px-3 py-1.5 text-sm rounded-full transition-colors ${closingSubstageFilter === 'bloccata' ? 'bg-yellow-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1682">
                      Bloccata
                    </button>
                    <button onClick={() => setClosingSubstageFilter('rifiutata')} className={`px-3 py-1.5 text-sm rounded-full transition-colors ${closingSubstageFilter === 'rifiutata' ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1683">
                      Rifiutata
                    </button>
                  </div>}
              </div>
              <div className="overflow-x-auto" data-id="element-1684">
                <table className="w-full" data-id="element-1685">
                  <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1686">
                    <tr data-id="element-1687">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1688">
                        Immobile
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1689">
                        Brand
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1690">
                        Responsabile
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1691">
                        Tipologia
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1692">
                        Fase
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1693">
                        Valore
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1694">
                        Data
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1695">
                    {getDealsByStage(selectedPipelineStage).map(deal => <tr key={deal.id} className="hover:bg-gray-50 transition-colors" data-id="element-1696">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1697">
                          <p className="text-sm font-medium text-gray-900" data-id="element-1698">
                            {deal.property}
                          </p>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1699">
                          <p className="text-sm text-gray-600" data-id="element-1700">{deal.brand}</p>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1701">
                          <div className="flex items-center gap-2" data-id="element-1702">
                            {deal.profileImage ? <img src={deal.profileImage} alt={deal.assignedTo} className="w-8 h-8 rounded-full object-cover" data-id="element-1703" /> : <div className="w-8 h-8 rounded-full bg-[#1388ad] text-white flex items-center justify-center text-xs font-medium" data-id="element-1704">
                                {deal.assignedTo.split(' ').map(n => n[0]).join('')}
                              </div>}
                            <span className="text-sm text-gray-600" data-id="element-1705">
                              {deal.assignedTo}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1706">
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1707">
                            {deal.dealType === 'retail' ? <>
                                <Store className="w-3 h-3" data-id="element-1708" />
                                Retail
                              </> : <>
                                <TrendingUp className="w-3 h-3" data-id="element-1709" />
                                Investment
                              </>}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1710">
                          {selectedPipelineStage === 'closing' && deal.closingSubstage ? <span className={`px-3 py-1 text-xs rounded-full ${closingSubstageColors[deal.closingSubstage]}`} data-id="element-1711">
                              {getClosingSubstageLabel(deal.closingSubstage)}
                            </span> : <span className={`px-3 py-1 text-xs ${stageColors[getStageDisplayName(deal.stage)] || 'bg-gray-100 text-gray-800 rounded-full'}`} data-id="element-1712">
                              {getStageDisplayName(deal.stage)}
                            </span>}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1713">
                          <p className="text-sm font-medium text-[#1388ad]" data-id="element-1714">
                            €{deal.value.toLocaleString()}
                          </p>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1715">
                          <p className="text-sm text-gray-500" data-id="element-1716">{deal.date}</p>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </div>}
      {/* New Deal Modal */}
      {showNewDealModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1717">
          <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg" data-id="element-1718">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between" data-id="element-1719">
              <div data-id="element-1720">
                <h2 className="text-xl font-semibold text-gray-900" data-id="element-1721">
                  Nuova Trattativa
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1722">
                  Crea una nuova trattativa da record esistente o da esigenza
                </p>
              </div>
              <button onClick={() => {
            setShowNewDealModal(false);
            setShowSuggestions(false);
          }} className="p-2 hover:bg-gray-100 transition-colors rounded-lg" data-id="element-1723">
                <X className="w-5 h-5 text-gray-500" data-id="element-1724" />
              </button>
            </div>
            <div className="p-6 space-y-6" data-id="element-1725">
              {/* Deal Type Toggle */}
              <div data-id="element-1726">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-1727">
                  Tipologia Trattativa
                </label>
                <div className="flex gap-3" data-id="element-1728">
                  <button onClick={() => setNewDealType('retail')} className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${newDealType === 'retail' ? 'border-[#1388ad] bg-[#1388ad]/5 text-[#1388ad]' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`} data-id="element-1729">
                    <Store className="w-5 h-5" data-id="element-1730" />
                    <span className="font-medium" data-id="element-1731">Retail</span>
                  </button>
                  <button onClick={() => setNewDealType('investment')} className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${newDealType === 'investment' ? 'border-[#6bb2cd] bg-[#6bb2cd]/5 text-[#6bb2cd]' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`} data-id="element-1732">
                    <TrendingUp className="w-5 h-5" data-id="element-1733" />
                    <span className="font-medium" data-id="element-1734">Investment</span>
                  </button>
                </div>
              </div>
              {/* Creation Type Toggle */}
              <div className="grid grid-cols-2 gap-3" data-id="element-1735">
                <button onClick={() => {
              setCreationType('existing');
              setShowSuggestions(false);
            }} className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${creationType === 'existing' ? 'border-[#1388ad] bg-[#1388ad]/5 text-[#1388ad]' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`} data-id="element-1736">
                  <Building2 className="w-5 h-5" data-id="element-1737" />
                  <span data-id="element-1738">Trattativa Esistente</span>
                </button>
                <button onClick={() => {
              setCreationType('requirement');
              setShowSuggestions(false);
            }} className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-colors ${creationType === 'requirement' ? 'border-[#1388ad] bg-[#1388ad]/5 text-[#1388ad]' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`} data-id="element-1739">
                  <Target className="w-5 h-5" data-id="element-1740" />
                  <span data-id="element-1741">Da Esigenza Brand</span>
                </button>
              </div>
              {/* Existing Deal Form */}
              {creationType === 'existing' && <div className="space-y-4" data-id="element-1742">
                  <div className="grid grid-cols-2 gap-4" data-id="element-1743">
                    <div data-id="element-1744">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1745">
                        Immobile
                      </label>
                      <select value={selectedProperty} onChange={e => setSelectedProperty(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1746">
                        <option value="" data-id="element-1747">Seleziona immobile</option>
                        {mockProperties.map(prop => <option key={prop.id} value={prop.id} data-id="element-1748">
                            {prop.name} - {prop.type} - {prop.size}m²
                          </option>)}
                      </select>
                    </div>
                    <div data-id="element-1749">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1750">
                        Brand
                      </label>
                      <select value={selectedBrand} onChange={e => setSelectedBrand(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1751">
                        <option value="" data-id="element-1752">Seleziona brand</option>
                        {mockBrands.map(brand => <option key={brand.id} value={brand.id} data-id="element-1753">
                            {brand.name}
                          </option>)}
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1754">
                    <div data-id="element-1755">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1756">
                        Stato
                      </label>
                      <select value={selectedStage} onChange={e => setSelectedStage(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1757">
                        <option value="" data-id="element-1758">Seleziona stato</option>
                        <option value="interesse" data-id="element-1759">Interesse</option>
                        <option value="proposta" data-id="element-1760">Proposta</option>
                        <option value="trattativa" data-id="element-1761">Trattativa</option>
                        <option value="chiusa" data-id="element-1762">Chiusa</option>
                      </select>
                    </div>
                    <div data-id="element-1763">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1764">
                        Valore (€)
                      </label>
                      <input type="number" value={dealValue} onChange={e => setDealValue(e.target.value)} placeholder="850000" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1765" />
                    </div>
                  </div>
                </div>}
              {/* Requirement-based Deal Form */}
              {creationType === 'requirement' && <div className="space-y-4" data-id="element-1766">
                  <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-1767">
                    <div className="flex gap-2" data-id="element-1768">
                      <Sparkles className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-1769" />
                      <div data-id="element-1770">
                        <p className="text-sm font-medium text-blue-900" data-id="element-1771">
                          Suggerimenti AI
                        </p>
                        <p className="text-xs text-blue-800 mt-1" data-id="element-1772">
                          Inserisci le esigenze del brand e l'AI suggerirà gli
                          immobili più adatti
                        </p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1773">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1774">
                      Brand
                    </label>
                    <select value={requirementBrand} onChange={e => setRequirementBrand(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1775">
                      <option value="" data-id="element-1776">Seleziona brand</option>
                      {mockBrands.map(brand => <option key={brand.id} value={brand.id} data-id="element-1777">
                          {brand.name}
                        </option>)}
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1778">
                    <div data-id="element-1779">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1780">
                        Tipologia
                      </label>
                      <select value={requirementType} onChange={e => setRequirementType(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1781">
                        <option value="" data-id="element-1782">Seleziona tipologia</option>
                        <option value="retail" data-id="element-1783">Retail</option>
                        <option value="showroom" data-id="element-1784">Showroom</option>
                        <option value="boutique" data-id="element-1785">Boutique</option>
                      </select>
                    </div>
                    <div data-id="element-1786">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1787">
                        Budget (€)
                      </label>
                      <input type="text" value={requirementBudget} onChange={e => setRequirementBudget(e.target.value)} placeholder="800k-1M" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1788" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1789">
                    <div data-id="element-1790">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1791">
                        Metratura (m²)
                      </label>
                      <input type="text" value={requirementSize} onChange={e => setRequirementSize(e.target.value)} placeholder="100-150" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1792" />
                    </div>
                    <div data-id="element-1793">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1794">
                        Zona Preferita
                      </label>
                      <input type="text" value={requirementZone} onChange={e => setRequirementZone(e.target.value)} placeholder="Montenapoleone, Via della Spiga..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1795" />
                    </div>
                  </div>
                  <div data-id="element-1796">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1797">
                      Note Aggiuntive
                    </label>
                    <textarea value={requirementNotes} onChange={e => setRequirementNotes(e.target.value)} rows={3} placeholder="Caratteristiche specifiche richieste..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] resize-none" data-id="element-1798" />
                  </div>
                  {!showSuggestions && <button onClick={handleAnalyzeRequirement} disabled={!requirementBrand || !requirementType || !requirementBudget} className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-1799">
                      {isAnalyzing ? <>
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1800" />
                          Analisi in corso...
                        </> : <>
                          <Sparkles className="w-5 h-5" data-id="element-1801" />
                          Analizza con AI
                        </>}
                    </button>}
                  {showSuggestions && <div className="space-y-4 pt-4 border-t border-gray-200" data-id="element-1802">
                      <div className="flex items-center justify-between" data-id="element-1803">
                        <h3 className="text-sm font-semibold text-gray-900" data-id="element-1804">
                          Immobili Suggeriti dall'AI
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-1805">
                          {mockSuggestedProperties.length} risultati
                        </span>
                      </div>
                      <div className="space-y-3" data-id="element-1806">
                        {mockSuggestedProperties.map(property => <div key={property.id} className="p-4 border-2 border-gray-200 rounded-lg hover:border-[#1388ad] transition-colors cursor-pointer" data-id="element-1807">
                            <div className="flex gap-4" data-id="element-1808">
                              <img src={property.image} alt={property.name} className="w-24 h-24 object-cover rounded-lg flex-shrink-0" data-id="element-1809" />
                              <div className="flex-1" data-id="element-1810">
                                <div className="flex items-start justify-between mb-2" data-id="element-1811">
                                  <div data-id="element-1812">
                                    <p className="text-sm font-semibold text-gray-900" data-id="element-1813">
                                      {property.name}
                                    </p>
                                    <p className="text-xs text-gray-500" data-id="element-1814">
                                      {property.type} • {property.size}m²
                                    </p>
                                  </div>
                                  <div className="flex items-center gap-1 px-2 py-1 bg-[#1388ad]/10 rounded-full" data-id="element-1815">
                                    <span className="text-xs font-semibold text-[#1388ad]" data-id="element-1816">
                                      {property.matchScore}%
                                    </span>
                                  </div>
                                </div>
                                <p className="text-xs text-gray-600 mb-2" data-id="element-1817">
                                  {property.reason}
                                </p>
                                <p className="text-sm font-semibold text-[#1388ad]" data-id="element-1818">
                                  €{property.price.toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </div>)}
                      </div>
                    </div>}
                </div>}
              {/* Action Buttons */}
              <div className="flex gap-3 pt-4 border-t border-gray-200" data-id="element-1819">
                <button onClick={() => {
              setShowNewDealModal(false);
              setShowSuggestions(false);
            }} className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1820">
                  Annulla
                </button>
                <button onClick={handleCreateDeal} disabled={creationType === 'existing' ? !selectedProperty || !selectedBrand || !selectedStage : !showSuggestions} className="flex-1 px-6 py-3 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-1821">
                  Crea Trattativa
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}